module.exports = __webpack_public_path__ + "img/1557614085515845634.25f5c483.png";